import { render, staticRenderFns } from "./CatalogContentSwitcher.vue?vue&type=template&id=3f1885e0&"
import script from "./CatalogContentSwitcher.js?vue&type=script&lang=js&"
export * from "./CatalogContentSwitcher.js?vue&type=script&lang=js&"
import style0 from "./CatalogContentSwitcher.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CatalogContentSwitcher.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fcomponents%2Fcatalog%2FCatalogContentSwitcher%2FCatalogContentSwitcher.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports